/* eslint-disable @typescript-eslint/no-unused-vars */
import { TFunction } from "next-i18next";
import { ArrowRightOutlineIcon } from "@smile2impress/components";
import { withCdnUrl } from "@smile2impress/attraction-utils";
import { BaseLayoutContent } from "layouts/relaunch/RelaunchLayout/RelaunchLayout.types";
import { UTSLocaleToCountryVersion } from "@smile2impress/attraction-constants";

import { SocialTypes } from "constants/enum";
import contacts from "configs/contacts";
import { getCurrentYear } from "utils/date";
import { PageContentProps } from "content/content.types";
import {
    OFFERS_AND_DISCOUNTS_LINKS_BY_LOCALE,
    PRIVACY_POLICY_LINKS_BY_LOCALE,
    UrlsConfig,
} from "configs/urlsConfig";

const pageContent = (
    t: TFunction,
    { locale }: PageContentProps
): BaseLayoutContent => {
    // eslint-disable-next-line unused-imports/no-unused-vars -- full menu snapshot, not returned yet
    // @ts-ignore TS6133
    const _fullContent = {
        header: {
            menuTitle: t("navigationMenuRelaunch:navigationMenu"),
            logoLink: UrlsConfig.MAIN,
            items: [
                {
                    text: t("navigationMenuRelaunch:clusterBAlignersGroup"),
                    highlighted: true,
                    items: [
                        {
                            text: t(
                                "navigationMenuRelaunch:clusterBOurAligners"
                            ),
                            link: UrlsConfig.ALIGNERS,
                            image: {
                                images: [
                                    {
                                        webp: withCdnUrl(
                                            "/images/relaunch/common/navigation/clusterB/aligners.webp"
                                        ),
                                    },
                                ],
                                defaultSrc: withCdnUrl(
                                    "/images/relaunch/common/navigation/clusterB/aligners.webp"
                                ),
                            },
                        },
                        {
                            text: t("navigationMenuRelaunch:navigationTeens"),
                            link: UrlsConfig.TEENS,
                            image: {
                                images: [
                                    {
                                        png: withCdnUrl(
                                            "/images/relaunch/common/navigation/teens.png"
                                        ),
                                    },
                                ],
                                defaultSrc: withCdnUrl(
                                    "/images/relaunch/common/navigation/teens.png"
                                ),
                            },
                        },
                        {
                            text: t("navigationMenuRelaunch:clusterBRetainers"),
                            link: UrlsConfig.RETAINERS_SUBSCRIPTION,
                            image: {
                                images: [
                                    {
                                        webp: withCdnUrl(
                                            "/images/relaunch/common/navigation/clusterB/retainers.webp"
                                        ),
                                    },
                                ],
                                defaultSrc: withCdnUrl(
                                    "/images/relaunch/common/navigation/clusterB/retainers.webp"
                                ),
                            },
                        },
                    ],
                },
                {
                    text: t("navigationMenuRelaunch:navigationWhy"),
                    link: UrlsConfig.WHY_IMPRESS,
                    image: {
                        images: [
                            {
                                png: withCdnUrl(
                                    "/images/relaunch/common/navigation/whyImpress.png"
                                ),
                            },
                        ],
                        defaultSrc: withCdnUrl(
                            "/images/relaunch/common/navigation/whyImpress.png"
                        ),
                    },
                },
                {
                    text: t("navigationMenuRelaunch:navigationPricing"),
                    link: UrlsConfig.PRICES,
                    image: {
                        images: [
                            {
                                png: withCdnUrl(
                                    "/images/relaunch/common/navigation/prices.png"
                                ),
                            },
                        ],
                        defaultSrc: withCdnUrl(
                            "/images/relaunch/common/navigation/prices.png"
                        ),
                    },
                },
                {
                    text: t("navigationMenuRelaunch:navigationClinics"),
                    link: UrlsConfig.LOCATIONS,
                    image: {
                        images: [
                            {
                                png: withCdnUrl(
                                    "/images/relaunch/common/navigation/locations.png"
                                ),
                            },
                        ],
                        defaultSrc: withCdnUrl(
                            "/images/relaunch/common/navigation/locations.png"
                        ),
                    },
                },
                {
                    text: t("navigationMenuRelaunch:navigationResults"),
                    link: UrlsConfig.RESULTS,
                    image: {
                        images: [
                            {
                                png: withCdnUrl(
                                    "/images/relaunch/common/navigation/results.png"
                                ),
                            },
                        ],
                        defaultSrc: withCdnUrl(
                            "/images/relaunch/common/navigation/results.png"
                        ),
                    },
                },
            ],
            cta: {
                text: t("navigationMenuRelaunch:navigationCTA"),
                link: UrlsConfig.UNIVERSAL_FORM,
            },
            ctaExpanded: {
                text: t("navigationMenuRelaunch:navigationCTA2"),
                link: UrlsConfig.UNIVERSAL_FORM,
                iconRight: ArrowRightOutlineIcon,
            },
            candidate: {
                text: t("navigationMenuRelaunch:navigationQuiz"),
                link: UrlsConfig.CANDIDATE,
            },
        },
        contacts: {
            wa: {
                text: t("navigationMenuRelaunch:navigationWhatsApp"),
                link: contacts.whatsapp[locale].link,
                message: t("global:whatsappMessage"),
            },
        },
        footer: {
            company: {
                title: t("global:companyFooterText"),
                links: [
                    {
                        id: "whyImpress",
                        name: t("global:whyImpressPageTitle"),
                        link: UrlsConfig.WHY_IMPRESS,
                    },
                    {
                        id: "careers",
                        name: t("global:careersPageTitle"),
                        link: "https://www.linkedin.com/company/impress-orthodontics/jobs/",
                    },
                    {
                        id: "offersAndDiscounts",
                        name: t("navigationMenuRelaunch:offersAndDiscounts"),
                        link: OFFERS_AND_DISCOUNTS_LINKS_BY_LOCALE[locale],
                    },
                    {
                        id: "locations",
                        name: t("navigationMenuRelaunch:navigationClinics"),
                        link: UrlsConfig.LOCATIONS,
                    },
                ],
            },
            product: {
                title: t("global:productFooterText"),
                links: [
                    {
                        name: t(
                            "navigationMenuRelaunch:clusterBTransparentAligners"
                        ),
                        link: UrlsConfig.ALIGNERS,
                    },
                    {
                        name: t("global:teensPageTitle"),
                        link: UrlsConfig.TEENS,
                    },
                    {
                        name: t("global:nightRetainersPageTitle"),
                        link: UrlsConfig.RETAINERS_SUBSCRIPTION,
                    },
                ],
            },
            legal: {
                title: t("global:legalNoticeFooterTitle"),
                links: [
                    {
                        id: "privacyPolicyPage",
                        name: t("global:privacyPolicy"),
                        link: PRIVACY_POLICY_LINKS_BY_LOCALE[locale],
                    },
                    {
                        id: "cookiesPage",
                        name: t("global:cookiesPolicy"),
                        link: withCdnUrl(
                            `${UrlsConfig.POLICY}/cookies-policy_${UTSLocaleToCountryVersion[locale]}.pdf`
                        ),
                    },
                ],
            },
            support: {
                title: t("global:supportFooterText"),
                links: [
                    {
                        id: "faq",
                        name: t("global:faqFooterText"),
                        link: "https://faq.smile2impress.com/de",
                    },
                    {
                        name: t("global:messageChat"),
                        link: (contacts.whatsapp[locale] as any).link,
                    },
                    {
                        name: contacts.phone[locale].public,
                        link:
                            contacts.phone[locale].link &&
                            `tel:${contacts.phone[locale].link}`,
                    },
                ],
            },
            disclaimerContent: t("global:disclaimerContent"),
            copyright: {
                text: `© ${getCurrentYear()} SMILE2IMPRESS SL. ${t(
                    "global:copyright"
                )}`,
            },
            socialNetworks: [
                {
                    iconName: SocialTypes.INSTAGRAM,
                    link: contacts.instagram[locale].link,
                },
                {
                    iconName: SocialTypes.LINKDIN,
                    link: contacts.linkdin[locale].link,
                },
                {
                    iconName: SocialTypes.TIKTOK,
                    link: contacts.tiktok[locale].link,
                },
            ],
            workingHours: {
                weekdays: t("global:workingHours.weekdays"),
                weekends: t("global:workingHours.weekends"),
            },
        },
    };
    return {
        header: {
            menuTitle: t("navigationMenuRelaunch:navigationMenu"),
            logoLink: UrlsConfig.MAIN,
            items: [],
            cta: {
                text: t("navigationMenuRelaunch:navigationCTA"),
                link: UrlsConfig.UNIVERSAL_FORM,
            },
            ctaExpanded: {
                text: t("navigationMenuRelaunch:navigationCTA2"),
                link: UrlsConfig.UNIVERSAL_FORM,
                iconRight: ArrowRightOutlineIcon,
            },
            candidate: undefined,
        },
        contacts: {
            wa: {
                text: t("navigationMenuRelaunch:navigationWhatsApp"),
                link: contacts.whatsapp[locale].link,
                message: t("global:whatsappMessage"),
            },
        },
        footer: {
            company: {
                title: t("global:companyFooterText"),
                links: [],
            },
            product: {
                title: t("global:productFooterText"),
                links: [],
            },
            legal: {
                title: t("global:legalNoticeFooterTitle"),
                links: [
                    {
                        name: t("navigationMenuRelaunch:clusterBImpressum"),
                        link: "http://smile2impress-5970216.hs-sites.com//legal/imprint/",
                    },
                    {
                        name: t(
                            "navigationMenuRelaunch:clusterBDataProtection"
                        ),
                        link: PRIVACY_POLICY_LINKS_BY_LOCALE[locale],
                    },
                ],
            },
            support: {
                title: t("global:supportFooterText"),
                links: [],
            },
            disclaimerContent: t("global:disclaimerContent"),
            disclaimerContentInExperiment: t(
                "global:disclaimerContentExperiment"
            ),
            copyright: {
                text: `© ${getCurrentYear()} SMILE2IMPRESS SL. ${t(
                    "global:copyright"
                )}`,
            },
            socialNetworks: [
                {
                    iconName: SocialTypes.INSTAGRAM,
                    link: contacts.instagram[locale].link,
                },
                {
                    iconName: SocialTypes.LINKDIN,
                    link: contacts.linkdin[locale].link,
                },
                {
                    iconName: SocialTypes.TIKTOK,
                    link: contacts.tiktok[locale].link,
                },
            ],
            workingHours: {
                weekdays: "",
                weekends: "",
            },
        },
    };
};

export default pageContent;
